import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, History, Plug, LogOut, Activity, Target, Globe2, Stethoscope, Search, TrendingUp, ListTodo } from "lucide-react";

const navItems = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/rearview", label: "Rearview", icon: History, testid: "nav-rearview" },
  { to: "/console", label: "Console", icon: Activity, testid: "nav-console" },
  { to: "/plan", label: "Plan", icon: Target, testid: "nav-plan" },
];

const seoNavItems = [
  { to: "/seo/homework", label: "Homework", icon: ListTodo, testid: "nav-seo-homework" },
  { to: "/seo/keywords", label: "Keywords", icon: Search, testid: "nav-seo-keywords" },
  { to: "/seo/traffic", label: "Organic Traffic", icon: TrendingUp, testid: "nav-seo-traffic" },
  { to: "/seo/competitors", label: "Competitor Watch", icon: Globe2, testid: "nav-seo-competitors" },
  { to: "/seo/page-health", label: "Page Health", icon: Stethoscope, testid: "nav-seo-page-health" },
];

const bottomNavItems = [
  { to: "/integrations", label: "Integrations", icon: Plug, testid: "nav-integrations" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex bg-warm">
      <aside className="w-64 shrink-0 bg-navy text-warm flex flex-col" data-testid="sidebar">
        <div className="px-5 pt-7 pb-5">
          <div className="text-yellow text-[10px] tracking-[0.3em] uppercase">Indie Law</div>
          <div className="mt-1 text-warm font-bold text-lg leading-tight">Marketing Intelligence</div>
          <div className="stripe-yellow mt-4" />
        </div>
        <nav className="flex-1 mt-2">
          {navItems.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.to === "/"}
              data-testid={it.testid}
              className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
            >
              <it.icon className="w-4 h-4" />
              <span>{it.label}</span>
            </NavLink>
          ))}
          <div className="px-5 pt-5 pb-1.5 text-[10px] uppercase tracking-[0.22em] text-yellow/80 font-bold">
            SEO
          </div>
          {seoNavItems.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              data-testid={it.testid}
              className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
            >
              <it.icon className="w-4 h-4" />
              <span>{it.label}</span>
            </NavLink>
          ))}
          <div className="mt-5 border-t border-yellow/20" />
          {bottomNavItems.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              data-testid={it.testid}
              className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
            >
              <it.icon className="w-4 h-4" />
              <span>{it.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="px-5 py-5 border-t border-yellow/20">
          <div className="text-[10px] tracking-[0.22em] uppercase opacity-60">Signed in</div>
          <div className="mt-1 text-sm">{user?.email}</div>
          <button onClick={logout} data-testid="logout-btn"
            className="mt-3 inline-flex items-center gap-2 text-xs text-yellow hover:underline">
            <LogOut className="w-3.5 h-3.5" /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
